﻿import * as viewport from '@storyous/responsive-bootstrap-toolkit/bootstrap-toolkit';

    var UOE_Rotator_controlButtonClick = function(event) {
        if (event.type === "click" || event.which === 13) {
            event.data.rotator.pause();
            event.data.rotator.transitionTo(event.data.index);
            event.preventDefault();
        }
    }

    //easiest way to get at these in a view is to make them global here.
    //the values don't actually matter as long as they're unique; so
    //we use things that will minify nicely.
    var UOE_Rotator_MobileOptions = { Normal: 1, Hide: 2, FirstItemOnly: 3, RandomSingleItem: 4 };

    var UOE_Rotator = function () { }

    UOE_Rotator.prototype = {

        init: function (options) {
            this.initialize(options.items, options);
        },

        initialize: function (rotatorItems, options) {

            //alias the really long property name
            var mo = UOE_Rotator_MobileOptions;


            // Set default values
            this.viewTime = 5000;
            this.transitionTime = 1000;
            this.initialDelay = 0;
            this.loop = true;
            this.paused = false;
            this.randomStart = false;
            this.createControls = false;
            this.controlParent = null;
            this.leftOffset = 0; //set to 15 for bootstrap normally? maybe fixed with relative row?

            //new features for the N2 version
            this.mobileOption = mo.Normal;
            this.mobileBreakpoint = "xs";

            // Merge supplied options
            $.extend(this, options || {});


            //Check mobile options; we may be done already...

            if (this.mobileOption !== mo.Normal && viewport.is('<=' + this.mobileBreakpoint)) {
                //hiding? get out of here now.
                if (this.mobileOption === mo.Hide) return;
                //first or random single only?
                if (this.mobileOption === mo.FirstItemOnly ||
                   this.mobileOption === mo.RandomSingleItem) {
                    //disable controls and rotation
                    this.createControls = false;
                    this.viewTime = 0;

                    //remove extra items from DOM
                    if (this.mobileOption === mo.FirstItemOnly) {
                        rotatorItems.slice(1).remove();
                    } else if (this.mobileOption === mo.RandomSingleItem) {
                        var rand = Math.floor(Math.random() * rotatorItems.length);
                        rotatorItems.not(":eq(" + rand + ")").remove();
                    }
                }
            }



            // Find my rotatables
            this.items = rotatorItems;
            this.itemCount = this.items.length;
            if (this.itemCount <= 1)
                return;
            $(this.items).hide()
				.css('position', 'absolute')
				.css('top', 0)
				.css('left', this.leftOffset);

            //store "This" for later. Existing code uses "rotator" but convention is "self" so 
            //we'll keep both.
            var rotator = this;
            var self = this;

            //legacy versions of the code used true to mean the same as ShowNumbers
            if (this.createControls !== false) {
                // Create item controls. Concession to bootstrap; we use a div because .btn-group requires buttons as immediate children,
                //so we can't have a ul button-group unless the LI is the button, which isn't right.
                //however, the buttons can be grouped into a fieldset, so the semantic relation is preserved.
                var controlList = $('<div class="btn-group"></div>');
                if (this.createControls === "ShowNumbers" || this.createControls === true) {
                    this.items.each(function (n) {
                        $('<button type="button" class="btn btn-xs"><span class="sr-only">Show slide </span>' + (n + 1) + '</button>')
					    .on("click keypress", { rotator: rotator, index: n }, UOE_Rotator_controlButtonClick)
					    .appendTo(controlList);
                    });
                }
                else if (this.createControls === "ShowArrows") {
                    $("<button type='button' class='btn btn-xs uoertr-previous-btn' aria-label='Previous slide'><i class='glyphicon glyphicon-chevron-left'></i></button>")
                    .on("click keypress", { rotator: rotator }, function (event) {
                        if (event.type === 'click' || event.which === 13) {
                            rotator.transitionPrev();
                            event.preventDefault();
                        }
                    })
                    .appendTo(controlList);

                    $("<button type='button' class='btn btn-xs uoertr-play-btn' aria-label='Start automatic rotation'><i class='glyphicon glyphicon-play'></i></button>")
                   .on("click keypress", { rotator: rotator }, function (event) {
                       if (event.type === 'click' || event.which === 13) {
                           rotator.play();
                           event.preventDefault();
                       }
                   })
                   .appendTo(controlList);

                    $("<button type='button' class='btn btn-xs uoertr-pause-btn' aria-label='Pause automatic rotation'><i class='glyphicon glyphicon-pause'></i></button>")
                 .on("click keypress", { rotator: rotator }, function (event) {
                     if (event.type === 'click' || event.which === 13) {
                         rotator.pause();
                         event.preventDefault();
                     }
                 })
                 .appendTo(controlList);

                    $("<button type='button' class='btn btn-xs uoertr-next-btn' aria-label='Next slide'><i class='glyphicon glyphicon-chevron-right'></i></button>")
                   .on("click keypress", { rotator: rotator }, function (event) {
                       if (event.type === 'click' || event.which === 13) {
                           rotator.transitionNext();
                           event.preventDefault();
                       }
                   })
                   .appendTo(controlList);
                }
                this.controlParent.append(controlList);
                this.controlItems = controlList.children('button');
            }


            // Show initial image.
            var start = 0;
            if (this.randomStart)
                start = Math.floor(Math.random() * this.itemCount);
            //this.transitionTo(start);
            this.currentIndex = start;
            this.items.eq(start).show();
            if (this.createControls === "ShowNumbers" || this.createControls === true) {
                this.controlItems.eq(start).addClass('active');
            } else if (this.createControls === "ShowArrows") {
                this.controlItems.eq(1).addClass('active');
            }


            // Start the timer after the initial delay.
            if (this.viewTime > 0)
                setTimeout(function () { rotator.startTimer(); }, this.initialDelay);
        },

        startTimer: function () {
            // If there was an initial delay, transition now.
            if (this.initialDelay > 0)
                this.autoTransition();

            var rotator = this;
            this.timer = setInterval(function () { rotator.autoTransition(); }, this.viewTime);
        },

        pause: function () {
            if (this.timer != null)
                clearInterval(this.timer);
            this.timer = null;
            this.paused = true;

            if (this.createControls === "ShowArrows") {
                this.controlItems.removeClass('active');
                this.controlItems.eq(2).addClass('active');
            }
        },

        play: function () {
            this.paused = false;
            this.startTimer();

            if (this.createControls === "ShowArrows") {
                this.controlItems.removeClass('active');
                this.controlItems.eq(1).addClass('active');
            }
        },

        autoTransition: function () {
            // If not looping and no more items, we're finished.
            if (!this.loop && this.currentIndex == this.itemCount - 1) {
                // Cancel timer
                clearInterval(this.timer);
                return;
            }

            this.transitionNext();
        },

        transitionNext: function () {
            var n = (this.currentIndex + 1) % this.itemCount;
            this.transitionTo(n);
        },

        transitionPrev: function () {
            var n = this.currentIndex == 0 ? this.itemCount - 1 : this.currentIndex - 1;
            this.transitionTo(n);
        },

        transitionTo: function (n) {
            if (this.currentIndex == n || n < 0 || n >= this.itemCount)
                return;

            // Fade out the current and fade in the next simultaneously.
            this.items.eq(this.currentIndex).fadeOut(this.transitionTime);
            this.items.eq(n).fadeIn(this.transitionTime);

            this.jumpTo(n);
        },

        jumpTo: function (n) {
            //bypasses fade
            if (this.currentIndex == n || n < 0 || n >= this.itemCount)
                return;

            if (this.createControls === "ShowNumbers" || this.createControls === true) {
                // Change the current contol
                this.controlItems.removeClass('active');
                this.controlItems.eq(n).addClass('active');
            }

            this.currentIndex = n;
            this.items.attr('aria-hidden', 'true');
            this.items.eq(n).attr('aria-hidden', 'false');
        }
    };

export default UOE_Rotator;